import { ConsoleFacade } from '@/shared/helpers';
import Vue from 'vue';
import * as TypedIdentityCardComponent from '@/public/identity-card/identity-card-component/identity-card-component';
import IdentityCardComponent from '@/public/identity-card/identity-card-component/identity-card-component.vue';
import {IdentityCard} from '@/public/identity-card/identity-card-component/identity-card-component';

export class IdentityCardModalOpener  {

    public static async openAsync(containerElement: Element, identity: IdentityCard, translations: { [key: string]: string; }, language: string): Promise<void> {

        const ComponentClass = Vue.extend(IdentityCardComponent);

        const instance = new ComponentClass({
            propsData: {
                identity,
                translations,
                language
            }
        });

        instance.$mount();

        ConsoleFacade.log(`Instancing and opening metrics modal component.`, instance, containerElement);

        containerElement.innerHTML = '';

        containerElement.appendChild(instance.$el);

        const typedInstance = instance as TypedIdentityCardComponent.default;

        await typedInstance.openModal();
    }
}
